<template>
    <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M5 12.5498C6.97656 10.9035 9.46761 10.002 12.04 10.002C14.6124 10.002 17.1034 10.9035 19.08 12.5498" />
        <path d="M1.42004 8.99979C4.34247 6.42376 8.10434 5.00244 12 5.00244C15.8957 5.00244 19.6576 6.42376 22.58 8.99979" />
        <path d="M8.53003 16.1102C9.54523 15.389 10.7597 15.0015 12.005 15.0015C13.2504 15.0015 14.4648 15.389 15.48 16.1102" />
        <path d="M12 20H12.01" />
    </g>
</template>
